import Vue from 'vue';
import './scss/main.scss';
import vCalendar from 'v-calendar';

Vue.use(vCalendar, { screens: { xsm: '440px' } });

import CalendarioVenda from './CalendarioVenda.vue';
import CalendarioVendaMobile from './CalendarioVendaMobile.vue';
import CalendarioVendaCombo from './CalendarioVendaCombo.vue';
import CalendarioVendaEvento from './CalendarioVendaEvento.vue';
import CalendarioVendaMobileEvento from './CalendarioVendaMobileEvento.vue';

new Vue({
    el: '#calendarioVendaApp',
    components: { CalendarioVenda, CalendarioVendaCombo, CalendarioVendaEvento },
});

new Vue({
    el: '#calendarioVendaAppMobile',
    components: { CalendarioVendaMobile, CalendarioVendaCombo, CalendarioVendaMobileEvento },
});

